const config = {
  // 注意: 微信小程序要求所有请求URL必须为HTTPS协议
  // 如部署小程序，请确保服务器已配置SSL证书并将此地址改为https://
  baseUrl: 'https://www.ygbpy.cn/api',
  h5Appid: 'wx65ee28164abf7746',
  debug: false,
  OSS_PROVIDER: 'qcloud',
  qrcodeUrl: 'https://www.ygbpy.cn/',
  version: '100'
}
module.exports = config